import React,{useEffect,useState} from "react";
import Select from "react-select";
import "./index.css";

const Styles = {
  control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      width: "100%",
  }),
  option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      display: "flex",
      flexDirection: "row",
      alignItems:"center"
  }),
};
const options = [
    {value:"Account management",label:"Account management"},
    {value:"Bugs",label: "Bugs"},
    {value:"Community management",label:"Community management"},
    {value:"Feature Request",label:"Feature Request"},
    {value:"Plans and pricing",label:"Plans and pricing"},
    {value:"Technical support",label:"Technical support"}
]
const SelectTicketModal = ({onOpenTicket})=>{
    const [selectedOption,setOption] = useState(null);
    
    function handleChange(selected){
        setOption(selected);
    }
   
    return (
      <div
        className="modal fade"
        id="select_ticket_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title">Create a support ticket and chat</p>
              <button
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <Select
                      options={options}
                      styles={Styles}
                      placeholder="Select your ticket type"
                      value={selectedOption}
                      onChange={handleChange}
                  />
                </div>
                <div className="row-div" style={{justifyContent:"space-around"}}>
                  <button
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!selectedOption}
                    onClick={()=>onOpenTicket(selectedOption)}
                  >
                    Create ticket
                  </button>
                  <button
                    className="btn btn-orange"
                    data-dismiss="modal"
                  >
                    Create later
                  </button>
                  
                  
                </div>
               
            </div>
          </div>
        </div>
      </div>
    );
}

export default SelectTicketModal;


// WEBPACK FOOTER //
// ./src/screens/AdminSupport/SelectTicketModal.js